export const themeColorMap = {
    primary: {
        backgroundColor: 'var(--color-invert)',
        color: 'var(--color-primary)',
    },
    invert: {
        backgroundColor: 'var(--color-primary)',
        color: 'var(--color-invert)',
    },
    white: {
        backgroundColor: 'rgba(243, 243, 242, 1)',
        color: 'var(--always-black)',
    },
};
